<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <!-- <b-card
          border-variant="info"
          header-bg-variant="primary"
          header-text-variant="white"
          header="Service Request Category Create"
        > -->
        <b-row>
          <b-col md="4">
            <span>Category</span>
          </b-col>
          <b-col md="8">
            <c-input inputType="text" lableText="Category" v-model="name" />
          </b-col>
        </b-row>
        <b-row v-if="userRole === 'Tenant' || userRole === 'Partner'">
          <b-col md="4">
            <span>Scope</span>
          </b-col>
          <b-col md="8">
            <eb-select
              type="text"
              v-model="scope"
              :options="scope1Options"
              label="label"
              placeholder="Select scope"
            ></eb-select>
          </b-col>
        </b-row>
        <b-row v-if="userRole === 'Admin'">
          <b-col md="4">
            <span>Scope</span>
          </b-col>
          <b-col md="8">
            <eb-select
              type="text"
              v-model="scope"
              :options="scopeOptions"
              label="label"
              placeholder="Select scope"
            ></eb-select>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="4">
            <span>Description</span>
          </b-col>
          <b-col md="8">
            <div class="form-group">
              <b-form-textarea
                v-model="description"
                placeholder="Enter something..."
                rows="3"
                max-rows="6"
              ></b-form-textarea>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="4">
            <span>Severity</span>
          </b-col>
          <b-col md="8">
            <eb-select
              type="text"
              v-model="severity"
              :options="severityOptions"
              label="label"
              placeholder="Select Severity"
            ></eb-select>
          </b-col>
        </b-row>
        <hr />
        <div class="text-center mt-3 mb-3">
          <eb-button
            classic="mr-1 btn-primary"
            text="Back"
            @click="(e) => $emit('created', e)"
          ></eb-button>
          <eb-button
            class="btn"
            classic="mr-1 btn-primary"
            text="Save"
            @click.prevent="handleSubmit"
          ></eb-button>
        </div>
        <!-- </b-card> -->
      </b-col>
    </b-row>
  </div>
</template>

<script>
import cInput from "@/components/Common/CustomInput";
import { shuffleArray } from "@/shared/utils";
import ebSelect from "@/components/FormElements/Select.vue";
import { Vue, Component, Prop } from "vue-property-decorator";
import axios from "axios";
import ebButton from "@/components/FormElements/Button";
import servicerequestdetails from "@/components/MasterSetup/ServiceRequest/ServiceRequestDetails.vue";

export default {
  name: "createrequest",
  components: {
    ebButton,
    cInput,
    ebSelect,
    servicerequestdetails,
  },
  data: () => {
    return {
      show: true,
      scope: "",
      scope1Options: ["AGENT", "PARTNER", "CUSTOMER"],
      scopeOptions: ["TENANT"],
      severityOptions: ["Low", "Medium", "High", "Critical"],
      name: "",
      severity: "",
      description: "",
    };
  },
  computed: {
    userRole() {
      if (this.$store.getters["auth/getUserRole"]) {
        return this.$store.getters["auth/getUserRole"];
      } else {
        return JSON.parse(sessionStorage.getItem("userLogin"))["role"];
      }
    },
  },
  methods: {
    handleSubmit() {
      let dataObj;
      dataObj = {
        parent: null,
        scope: this.scope,
        name: this.name,
        description: this.name,
        severity: this.severity,
      };
      this.$store.dispatch("servicerequest/createRequest", dataObj).then(() => {
        this.$swal({
          title: "Success",
          text: "Request added successfully!!",
          type: "success",
        });
        this.$emit("created", {});
        this.$store.dispatch(
          "servicerequest/fetchServicerequestList"
          // this.$store.getters["auth/getUserID"]
        );
      });
    },
  },
};
</script>
<style scoped>
.fa-plus {
  border-top-right-radius: 10px;
  border-top-left-radius: 17px;
  border-bottom-left-radius: 17px;
  background-color: #f0f3f5;
}
</style>
